export default __webpack_public_path__ + "static/google-play-large-9ecc04348353a171cfe7b99ef2ac551a.svg";